import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Grid} from './ui/grid';
import {Global} from './models/global';
import {Holiday} from './models/holiday';
import {parse} from 'date-fns';

declare var GLOBAL: Global;

const element = document.getElementById('dynamic-sprint-grid');

if (element) {
    ReactDOM.render(
        <React.StrictMode>
            <Grid
                offset={GLOBAL.offset}
                holidays={Object.keys(GLOBAL.holidays).reduce((holidays: Holiday[], date: string) => {
                    return [
                        ...holidays,
                        ...GLOBAL.holidays[date].map((name) => {
                            return {
                                date: parse(date, 'yyyy-MM-dd', new Date()),
                                name: name,
                            };
                        }),
                    ];
                }, [])}
                user={GLOBAL.user}
                availabilities={GLOBAL.availabilities}
                employees={Object.values(GLOBAL.employees)}
            />
        </React.StrictMode>,
        element,
    );
}
